import api from "../utils/api";
import { IComplianceResult } from "../types";

/**
 * Get compliance status for a specific cycle
 */
export const getCycleCompliance = async (cycleId: string): Promise<IComplianceResult> => {
  try {
    console.log('API: Fetching compliance for cycle:', cycleId);
    const res = await api.get(`/api/cycles/${cycleId}/compliance`);
    console.log('API: Cycle compliance response:', res.data);
    return res.data;
  } catch (error) {
    console.error('API: Error fetching cycle compliance:', error);
    throw error;
  }
};

/**
 * Get compliance summary for all active cycles for the authenticated user
 */
export const getUserComplianceSummary = async (userId: string): Promise<IComplianceResult[]> => {
  try {
    console.log('API: Fetching compliance summary for user:', userId);
    const res = await api.get(`/api/users/${userId}/compliance-summary`);
    console.log('API: User compliance summary response:', res.data);
    return res.data;
  } catch (error) {
    console.error('API: Error fetching user compliance summary:', error);
    throw error;
  }
};
